import VerificationNotes from './VerificationNotes';

export default VerificationNotes;
